import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import every from 'lodash/every';
import values from 'lodash/values';
import compact from 'lodash/compact';
import { mapGetters } from 'vuex';
import StoreAvailability from '~/services/store';
import _validateZipcode from '~/helpers/zipcode-validator-helper';
import LineOnSideHeader from '~/components/atoms/LineOnSideHeader.vue';
import TextField from '~/components/atoms/TextField.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-down.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/loupe.svg';

var MdmModal = function MdmModal() {
  return import(
  /* webpackChunkName: "modal" */
  '~/components/atoms/Global/MdmModal.vue');
};

var MANDATORY_FIELDS = ['zipcode'];
export default {
  name: 'StoreAvailabilityModal',
  components: {
    MdmModal: MdmModal,
    LineOnSideHeader: LineOnSideHeader,
    TextField: TextField
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      page: 1,
      stores: null,
      values: {
        zipcode: null
      },
      pendingRequest: false,
      formSuccess: false,
      showServerError: false,
      submitted: false,
      errors: {
        zipcode: false,
        zipcodeFormat: false
      }
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    zipcodeErrorMessage: function zipcodeErrorMessage() {
      return this.errors.zipcodeFormat ? this.$t('field_zip_code_invalid_error') : '';
    }
  }),
  watch: {
    values: {
      handler: function handler() {
        if (!this.submitted) {
          return;
        }

        this.validateMandatoryFields();
      },
      deep: true
    },
    'values.zipcode': function watchZipcode() {
      this.errors.zipcodeFormat = false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      if (window.woosmap) {
        var provider = new window.woosmap.ZipCodeProvider();
        _this.values.zipcode = provider.getZipCode();
      }
    }, 500);
  },
  methods: {
    validateZipcode: function validateZipcode() {
      var isoMarket = this.locale.iso.slice(-2);
      this.errors.zipcodeFormat = this.values.zipcode ? !_validateZipcode(this.values.zipcode, isoMarket) : false;
    },
    validateMandatoryFields: function validateMandatoryFields() {
      var _this2 = this;

      MANDATORY_FIELDS.forEach(function (field) {
        _this2.errors[field] = !_this2.values[field];
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.submitted = true;
      this.validateMandatoryFields();
      this.validateZipcode();

      if (every(this.errors, function (field) {
        return !field;
      })) {
        this.pendingRequest = true;
        this.page = 1;
        var stockClasses = {
          shop_stock_available: 'available',
          shop_stock_limited: 'limited',
          shop_stock_unavailable: 'unavailable'
        };
        StoreAvailability(this.$store, this.product.reference, this.values.zipcode).then(function (_ref) {
          var shops = _ref.shops;
          _this3.stores = values(shops).map(function (e) {
            return {
              id: e.id,
              city: e.city,
              address: compact([e.address, e.address2, e.address_complement]),
              phone: e.phone,
              distance: e.dist,
              distanceLabel: "".concat(e.dist, " km"),
              stockStatus: e.stock_status_label,
              stockClass: stockClasses[e.stock_status]
            };
          });
          _this3.pendingRequest = false;
          _this3.submitted = false;
        });
      }
    },
    more: function more() {
      this.page = this.page + 1;
    }
  }
};